/**
 * @generated SignedSource<<989b3739bda3c927f732d6194f9d8128>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkbookTaskConnectionDataTable_taskConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly difficulty: number | null;
      readonly id: string;
      readonly sequence: number;
      readonly unitD: {
        readonly unitATitle: string;
        readonly unitDTitle: string;
      } | null;
    };
  }>;
  readonly " $fragmentType": "WorkbookTaskConnectionDataTable_taskConnection";
};
export type WorkbookTaskConnectionDataTable_taskConnection$key = {
  readonly " $data"?: WorkbookTaskConnectionDataTable_taskConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkbookTaskConnectionDataTable_taskConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkbookTaskConnectionDataTable_taskConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UnitD",
              "kind": "LinkedField",
              "name": "unitD",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unitATitle",
                  "storageKey": null
                },
                {
                  "alias": "unitDTitle",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "difficulty",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskConnection",
  "abstractKey": null
};

(node as any).hash = "f5ea26210ee8c926d60dd8af64dcfcc3";

export default node;
